import $ from 'jquery';
class Contact {

    constructor(){
        //$('#contact-club-rep').attr('hidden',true);  
        //$('#contact-club').attr('hidden',true);  
        this.events();  
    }

    events() {
        //  Register Listeners
        $('#contact-to-group').on('change', this.checkRepSelect.bind(this));
        $("#contact-fromName").on("focus", this.resetColor.bind(this));      // Change color back to default
        $("#contact-fromPhone").on("focus", this.resetColor.bind(this));      // Change color back to default
        $("#contact-fromEmail").on("focus", this.resetColor.bind(this));      // Change color back to default
        $("#msgForm").on('submit', this.validateFields.bind(this));
    }

    resetColor(e){
        // Change color back to default
        $(e.target).css('border-color','');
    }

    validateFields(e){

        var allValid = true;
        //  Check whether some required fields are missing
        if (!validTextField($("#contact-fromName"),1)){
            allValid=false;
        }
        if (!validNumericField($("#contact-fromPhone"),0)){
            allValid=false;
        }
        if (!validEmailField($("#contact-fromEmail"), 1)){
            allValid=false;
        }
        if (!allValid){
            e.preventDefault();
        }
    }

    checkRepSelect(e){
        if ($('#contact-to-group').val()=='Club Rep'){
            $('#contact-club-rep').removeAttr('hidden');
            $('#contact-club').removeAttr('hidden');
        } else {
            $('#contact-club-rep').attr('hidden',true);
            $('#contact-club').attr('hidden',true);
        }
    }
}

function validTextField( field, minLength ){
    var fieldText = $(field).val();
    var fieldValid = true;
    if (fieldText.length < minLength ){
        fieldValid = false;
    } else {
        if (!fieldText.match(/^[A-Za-z ]+$/) && fieldText.length != 0){
            fieldValid = false;
        }
    }
    if (!fieldValid){
        field.css("border-color", "red");
    }
    return fieldValid;
}

function validNumericField( field, minLength ){
    var fieldText = $(field).val();
    var fieldValid = true;
    if (fieldText.length < minLength ){
        fieldValid = false;
    } else {
        if (!fieldText.match(/^[0-9 ]+$/) && fieldText.length != 0){
            fieldValid = false;
        }
    }
    if (!fieldValid){
        field.css("border-color", "red");
    }
    return fieldValid;
}

function validEmailField( field, minLength ){
    var fieldText = $(field).val();
    var fieldValid = true;
    if (fieldText.length < minLength ){
        fieldValid = false;
    } else {
        if (!fieldText.match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/)){
            fieldValid = false;
        }
    }
    if (!fieldValid){
        field.css("border-color", "red");
    }
    return fieldValid;
}

export default Contact;

